import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Link Content with course Lecture
 * @param course_id
 * @param version
 * @param sectionId
 * @param lectureId
 * @param contentId
 */
const linkCourseLectureWithContent = (
  course_id: string,
  version: number,
  sectionId: string,
  lectureId: string,
  contentId: string
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL =
      routes.COURSE +
      course_id +
      '/' +
      version +
      '/sections/' +
      sectionId +
      '/lectures/' +
      lectureId +
      '/contents/' +
      contentId +
      '/link'
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }

    AxiosClient.post(URL, {}, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject('Error linking lecture with content occurred: ' + err)
      })
  })
}

export default linkCourseLectureWithContent
